import styled from 'styled-components';

export const MonitoringReportRefreshTimerStyle = styled.div`
  padding-left: 40px;
  display: flex;
  padding-top: 10px;
  margin-bottom: -70px;

  .monitoring-time{
    margin-left: 10px;
  }

  .monitoring-refresh-timer-button{
    padding: 20px;
    margin-top: 5px;
  }
  .MuiFormGroup-root{
    padding-right: 15px;
  }
`;
